module.exports = __webpack_public_path__ + "img/welcome5.9353cf95.png";